import React from "react";

const renderSettings: React.FC<any> = ({ block }: any) => {
    return <div></div>;
};

export default renderSettings;
